class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const renderToken = ++FacetFiltersForm.renderToken;
    // Avoid serving stale section HTML after filter/markup changes
    FacetFiltersForm.filterData = [];
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, renderToken)
        : FacetFiltersForm.renderSectionFromFetch(url, event, renderToken);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, renderToken) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        if (renderToken !== FacetFiltersForm.renderToken) return;
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, renderToken) {
    if (renderToken !== FacetFiltersForm.renderToken) return;
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const source = parsedHTML.getElementById('ProductCount');
    const sourceDesktop = parsedHTML.getElementById('ProductCountDesktop');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const count = sourceDesktop?.innerHTML || source?.innerHTML;

    if (container && count !== undefined) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop && count !== undefined) {
      containerDesktop.innerHTML = sourceDesktop?.innerHTML || count;
      containerDesktop.classList.remove('loading');
    }

    const drawerCount = document.querySelector('.mobile-facets__count');
    const drawerCountSource = parsedHTML.querySelector('.mobile-facets__count');
    if (drawerCount && drawerCountSource) {
      drawerCount.innerHTML = drawerCountSource.innerHTML;
    }

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter:not(.accordion-item), #FacetFiltersFormMobile .js-filter:not(.accordion-item), #FacetFiltersPillsForm .js-filter:not(.accordion-item)'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter:not(.accordion-item), #FacetFiltersFormMobile .js-filter:not(.accordion-item), #FacetFiltersPillsForm .js-filter:not(.accordion-item)'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.renderAccordionFilters(parsedHTML);

    if (countsToRender) {
      const closestJSFilter = event.target.closest('.js-filter');
      const closestJSFilterID = closestJSFilter && closestJSFilter.id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, closestJSFilter);
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderAccordionFilters(html) {
    const openLabelsByWrapper = new Map();

    ['#FacetsWrapperDesktop', '#FacetsWrapperMobile'].forEach((wrapperSelector) => {
      const currentWrapper = document.querySelector(wrapperSelector);
      const newWrapper = html.querySelector(wrapperSelector);
      if (!currentWrapper || !newWrapper) return;

      const currentAccordion = currentWrapper.querySelector('accordion-items');
      const newAccordion = newWrapper.querySelector('accordion-items');
      if (!currentAccordion || !newAccordion) return;

      const openLabels = Array.from(currentAccordion.querySelectorAll('.accordion-item.active .accordion-header span'))
        .map((el) => el.textContent.trim())
        .filter(Boolean);
      openLabelsByWrapper.set(wrapperSelector, openLabels);

      currentAccordion.outerHTML = newAccordion.outerHTML;

      const replacedAccordion = currentWrapper.querySelector('accordion-items');
      if (!replacedAccordion) return;

      const labelsToOpen = openLabelsByWrapper.get(wrapperSelector) || [];
      replacedAccordion.querySelectorAll('.accordion-item').forEach((item) => {
        const label = item.querySelector('.accordion-header span')?.textContent.trim();
        const shouldOpen = labelsToOpen.includes(label);
        item.classList.toggle('active', shouldOpen);
        const content = item.querySelector('.accordion-content');
        if (content) {
          content.style.maxHeight = shouldOpen ? `${content.scrollHeight}px` : null;
        }
      });
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const sourceElements = html.querySelectorAll(selector);
      const destinationElements = document.querySelectorAll(selector);

      destinationElements.forEach((destination, index) => {
        const source = sourceElements[index];
        if (source) destination.innerHTML = source.innerHTML;
      });
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const destination = document.querySelector(selector);
      if (!destination) return;
      destination.innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const menuDrawer = mobileForm && mobileForm.closest('menu-drawer');
    if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
      menuDrawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      if (key.includes('price-preset')) continue;
      if ((key.includes('price.gte') || key.includes('price.lte')) && value === '') continue;
      params.append(key, value);
    }
    return params.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const currentForm = event.target.closest('form');
      const isMobile = currentForm && currentForm.id === 'FacetFiltersFormMobile';
      const isDrawerSort = currentForm && currentForm.id === 'FacetSortDrawerForm';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
          // Drawer sort lives outside the filter form — keep active drawer filters
          if (isDrawerSort && form.id === 'FacetFiltersFormMobile') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  static applyAndCloseMobileFilters(button) {
    const form = button.closest('form');
    const facetForm = button.closest('facet-filters-form');
    if (!form || !facetForm) return;

    const searchParams = facetForm.createSearchParams(form);
    FacetFiltersForm.renderPage(searchParams);

    const drawer = button.closest('menu-drawer');
    const summary = button.closest('.mobile-facets__wrapper')?.querySelector('summary');
    if (drawer && summary && typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(new Event('click'), summary);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.renderToken = 0;
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.closeFilter = this.closeFilter.bind(this);
  }

  connectedCallback() {
    const facetLink = this.querySelector('a');
    if (!facetLink || facetLink.dataset.facetRemoveBound === 'true') return;
    facetLink.dataset.facetRemoveBound = 'true';
    facetLink.setAttribute('role', 'button');
    facetLink.classList.add('js-facet-remove');
    facetLink.addEventListener('click', this.closeFilter);
    facetLink.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.closeFilter(event);
      }
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form) form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class PriceRangePresets extends HTMLElement {
  connectedCallback() {
    this.minInput = this.querySelector('.price-range-presets__gte');
    this.maxInput = this.querySelector('.price-range-presets__lte');

    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('input', (event) => event.stopPropagation());
      radio.addEventListener('change', this.onPresetChange.bind(this));
    });
  }

  onPresetChange(event) {
    event.stopPropagation();
    const radio = event.target;
    if (radio.type !== 'radio' || !radio.checked) return;

    const min = radio.getAttribute('data-min') ?? '';
    const max = radio.getAttribute('data-max') ?? '';

    if (this.minInput) this.minInput.value = min;
    if (this.maxInput) this.maxInput.value = max;

    this.querySelectorAll('.facet-checkbox').forEach((label) => {
      label.classList.toggle('active', label.contains(radio));
    });

    // Apply immediately (same approach as the previous slider) so FormData timing cannot drop values
    this.applyFilter(min, max);
  }

  applyFilter(min, max) {
    const form = this.closest('form');
    if (!form) return;

    const params = new URLSearchParams();

    // Keep existing non-price filters/sort from the current form
    new FormData(form).forEach((value, key) => {
      if (key.includes('price-preset')) return;
      if (key.includes('price.gte') || key.includes('price.lte')) return;
      if (value !== '') params.append(key, value);
    });

    // Merge sort from companion forms when price lives in a filters-only form
    if (form.id === 'FacetFiltersForm') {
      const sortForm = document.getElementById('FacetSortForm');
      if (sortForm) {
        new FormData(sortForm).forEach((value, key) => {
          if (value !== '' && !params.has(key)) params.append(key, value);
        });
      }
    } else if (form.id === 'FacetFiltersFormMobile') {
      const drawerSortForm = document.getElementById('FacetSortDrawerForm');
      if (drawerSortForm) {
        new FormData(drawerSortForm).forEach((value, key) => {
          if (value !== '' && !params.has(key)) params.append(key, value);
        });
      }
    }

    if (min !== '') params.set('filter.v.price.gte', String(min));
    if (max !== '') params.set('filter.v.price.lte', String(max));

    FacetFiltersForm.renderPage(params.toString());
  }
}

customElements.define('price-range-presets', PriceRangePresets);
